<template lang='pug'>
v-dialog(scrollable max-width='400px' v-model='dialog' persistent lazy)
  v-card(class='combo-card')
    v-card-title
      v-text-field(
        :loading='isLoading'
        ref='search'
        @input='onSearch'
        prepend-inner-icon='search'
        label='Поиск'
        hide-details
        clearable
      )
    v-card-text(style='height: 300px')
      //- Мультивыбор
      v-list(v-if='multiple' three-line class='multiple-select')
        v-list-tile(v-for='(item, index) in list' :key='index')
          v-list-tile-action
            v-checkbox(
              :value='item.id'
              @change='toggleMultipleSelect(item)'
              color='primary'
            )
          v-list-tile-content
              v-list-tile-title {{ item.office_name }}
              v-list-tile-sub-title
                span(class='text--primary') {{ item.department_name }},
                | {{ ' ' }}
                | {{ item.address_full }}
      //- Синглвыбор
      v-list(v-else three-line class='multiple-select')
        v-radio-group(v-for='(item, index) in list' v-model='selected' :key='index')
          v-list-tile
            v-list-tile-action
              v-radio(:value='item' :key='item.id' color='primary')
            v-list-tile-content
              v-list-tile-title {{ item.office_name }}
              v-list-tile-sub-title
                span(class='text--primary') {{ item.department_name }},
                | {{ ' ' }}
                | {{ item.address_full }}
    v-card-actions
      v-spacer
      v-btn(@click='$emit("close")' flat) Отмена
      v-btn(
        flat
        :disabled='disabled'
        color='primary'
        @click='$emit("select", multiple ? selectedMult : selected)'
      ) Ok
</template>

<script>
import http from '@/http'
import { debounce, find, xor } from 'lodash'

export default {
  props: ['dialog', 'managerId', 'multiple'],

  data: () => ({
    search: null,
    selectedMult: [],
    count: 50,
    selected: null,
    isLoading: false,
    list: []
  }),

  mounted() {
    if (this.dialog) {
      this.fetch()
    }
  },

  methods: {
    debouncedFetch: debounce(function() {
      let { search, count } = this
      this.fetchList({
        search,
        count,
        manager_id: this.managerId,
        not_in_depart: true
      })
    }, 250),

    async fetchList(params) {
      this.isLoading = true

      try {
        this.list = (await http.get('/admin/departments', {
          params
        })).data.data
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить список отделов')
      }

      this.isLoading = false
    },

    toggleMultipleSelect(item) {
      if (!item) return
      this.selectedMult = xor(this.selectedMult, [item])
    },

    onSearch(search) {
      this.search = search
    }
  },

  computed: {
    disabled() {
      return !(this.selected || this.selectedMult.length)
    },

    selectedOnce() {
      return find(this.list, {
        id: this.selected
      })
    }
  },

  watch: {
    dialog(opened) {
      if (opened) {
        this.debouncedFetch()

        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      } else {
        this.list = []
        this.selected = null
        this.selectedMult = []
      }
    },

    search: 'debouncedFetch'
  }
}
</script>

<style scoped>
.combo-card {
  height: 100%;
}
.multiple-select >>> .v-list__tile {
  padding: 0;
}
.multiple-select >>> .v-input {
  flex: 0;
}
</style>
